import { change, destroy } from 'redux-form';
import { replace } from 'react-router-redux';

import * as IndividualServingActions from 'PointOfSale/modules/individualServing/state/actions';
import { TransactionEnum } from 'Common/FieldEnum';
import { TRANSACTION_FORM_NAME } from 'Common/FormEnum';
import { POS_ROUTES } from 'PointOfSale/modules/common/constants';
import { fetchStudent } from 'PointOfSale/state/actions';

export const onSelect = profile => async (dispatch, getState) => {
  const [student] = await dispatch(
    fetchStudent(profile.IdSeed, { fetch: true, picture: true })
  );

  const currentProfile = {
    ...profile,
    ...student,
  };

  dispatch(IndividualServingActions.setCurrentProfile(currentProfile));
  dispatch(destroy(TRANSACTION_FORM_NAME));
  dispatch(
    change(TRANSACTION_FORM_NAME, TransactionEnum.StudentIdSeed, profile.IdSeed)
  );
  dispatch(replace(`${POS_ROUTES.OTHER}/${profile.Id}`));
};

export const remove = () => (dispatch, getState) => {
  dispatch(IndividualServingActions.clearCurrentProfile());
  dispatch(destroy(TRANSACTION_FORM_NAME));
  dispatch(replace(POS_ROUTES.OTHER));
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/other/state/actions.js